import React from "react";
import { TextField } from "@mui/material";

interface ModelNameProps {
  model: string;
}

const ModelName: React.FC<ModelNameProps> = ({ model }) => {
  return (
    <TextField
      className="qa_model_field"
      disabled
      label="Model"
      variant="filled"
      value={model}
      size="small"
      fullWidth
      sx={{
        "& .MuiInputLabel-root": {
          fontWeight: "bold",
          color: "#1976d2 !important",
        },
        "& .MuiInputBase-input": {
          fontSize: "20px",
          color: "#000000",
        },
      }}
    />
  );
};

export default ModelName;
